<template>
  <div class="contact">
    <div class="content">
      <div class="nav">联系我们</div>
      <el-form ref="form" :inline="true" :rules="rules" :model="form" class="demo-form-inline">
        <el-form-item prop="name">
          <el-input size="medium" v-model="form.name" placeholder="请输您的公司名称"></el-input>
        </el-form-item>
        <el-form-item prop="phone">
          <el-input v-model="form.phone" placeholder="请输入您的手机号"></el-input>
        </el-form-item>
        <el-form-item>
          <div class="btn" @click="onSubmit">提交对接意向</div>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import { addCrm } from '@/api/user'
export default {
  data() {
    const validatePhone = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入手机号'))
      } else {
        callback()
      }
    }
    const validateName = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入公司名称'))
      } else {
        callback()
      }
    }
    return {
      form: {
        phone: '',
        name: '',
        email: ''
      },
      rules: {
        phone: [{ validator: validatePhone, trigger: 'blur' }],
        name: [
          {
            validator: validateName,
            trigger: 'blur'
          }
        ]
      }
    }
  },
  methods: {
    onSubmit() {
      this.$refs.form.validate(valid => {
        if (valid) {
          addCrm(this.form).then(res => {
            this.form = {
              phone: '',
              name: '',
              email: ''
            }
            this.$message.success(res.data)
          })
        } else {
          return false
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.contact {
  margin-top: 120px;
  background: #3371ff;

  .content {
    width: 1920px;
    height: 299px;
    background-image: url('https://uifox-public.oss-cn-hangzhou.aliyuncs.com/common/introduce/contact.png');
    background-size: 100%;
    background-repeat: no-repeat;
    text-align: center;

    .nav {
      padding-top: 78px;
      font-size: 36px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #ffffff;
      letter-spacing: 2px;
      margin-bottom: 24px;
    }

    .btn {
      width: 380px;
      height: 48px;
      margin: 0 auto;
      background: linear-gradient(180deg, #ffa04d 0%, #ffba27 100%);
      border-radius: 24px;
      font-size: 18px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #ffffff;
      line-height: 48px;
      letter-spacing: 1px;
      cursor: pointer;
    }
  }
}

::v-deep .el-input {
  .el-input__inner {
    width: 380px;
    height: 48px;
    border-radius: 8px;
  }
}
</style>
